// extracted by mini-css-extract-plugin
export var addressInformationBubbleContainer = "_l6-0";
export var buttonContainer = "_l6-3";
export var cancelButton = "_l6-4";
export var headerSection = "_l6-6";
export var headerTitle = "_l6-9";
export var messageSideLeft = "_l6-1";
export var messageSideRight = "_l6-2";
export var orderNumberContainer = "_l6-7";
export var orderNumberLabel = "_l6-8";
export var submitButton = "_l6-5";